<template>
    <div>
        <v-data-table
                :headers="mainHeaders"
                :items="points"
                item-key="itemKey"
                dense
                group-by="admin_block_id"
                hide-default-footer
                search="12"
                :custom-filter="showNoSearch"
                class="elevation-1"
                :items-per-page="150"
                :item-class="itemClassFn"
        >
            <template v-slot:footer="{ footer }" v-if="calculateAdditional === 0">
                <div class="yellow darken-2 pl-4 pr-4 pt-2 pb-2">
                    {{ adminBlockName(14) }} [0] <v-btn class="ml-4" small @click="addMyQuestion" v-if="!!showAdminUI" color="success" title="Добавить новый вопрос"><v-icon small>mdi-plus</v-icon></v-btn>
                </div>
            </template>
            <template v-slot:group.header="{ group, isOpen, toggle, items }">
                <td class="yellow darken-2 pt-2 pb-2" :colspan="headers.length">{{ adminBlockName(group) }}
                    <v-btn v-if="Number(group) === 14" class="ml-4" small @click="addMyQuestion" color="success" title="Добавить новый вопрос"><v-icon small>mdi-plus</v-icon></v-btn>
                    <v-btn icon small @click="toggle" class="ml-4"><v-icon v-if="!!isOpen">mdi-chevron-up</v-icon><v-icon v-if="!isOpen">mdi-chevron-down</v-icon></v-btn></td>
            </template>
            <template v-slot:item.file="{ item }">
                <file-selector @change="change" v-model="item.file" :images="images" :mode="subMode"></file-selector>
            </template>
            <template v-slot:item.sto_file="{ item }">
                <sto-file-loader @change="change" v-model="item.sto_file" :stage="stage" :mode="subMode"></sto-file-loader>
            </template>
            <template v-slot:item.question="{ item }" >
                <v-btn icon small v-if="item.admin_block_id === 14 || !!deletemode" @click="deletePoint(item.itemKey)" class="mr-2"><v-icon small>mdi-delete</v-icon></v-btn> {{ item.question }}
            </template>
            <template v-slot:item.answer="{ item }" >
                <answer-place v-if="item.admin_block_id !== 14 && !!showAdminUI" @change="change" v-model="item.answer"></answer-place>
                <div v-if="!showAdminUI">{{ item.answer }}</div>
            </template>
            <template v-slot:item.last_point="{ item }">
                <span v-if="item.admin_block_id !== 14 && !showAdminUI">{{ item.last_point }}</span>
                <answer-place v-if="item.admin_block_id !== 14 && !!showAdminUI" @change="change" v-model="item.last_point"></answer-place>
                <v-tooltip v-if="item.admin_block_id !== 14 && item.last_point_comment">
                    <template v-slot:activator="{ on }">
                        <span v-on="on"><sup>*</sup></span>
                    </template>
                    <sup>{{ item.last_point_comment }}</sup>
                </v-tooltip>
            </template>
            <template v-slot:item.point_to_reports="{ item }">
                <span  v-if="item.admin_block_id !== 14">{{ item.point_to_reports }}</span>
            </template>
            <template v-slot:item.point="{ item }">
                <point-changer v-if="item.admin_block_id !== 14" v-model="item" :mode="subMode" @change="change"></point-changer>
            </template>
            <template v-slot:item.comment="{ item }">
                <comment-editor @change="change" v-model="item.comment" :mode="subMode" :stage="stage"></comment-editor>
            </template>
            <template v-slot:item.sto_comment="{ item }">
                <sto-comment-editor @change="change" :stage="stage" v-model="item.sto_comment" :mode="subMode"></sto-comment-editor>
            </template>
            <template v-slot:item.exclude="{ item }">
                <v-layout justify-center>
                    <v-checkbox dense v-model="item.exclude" :disabled="!showAdminUI" style="max-width: 80px" @change="change"></v-checkbox>
                </v-layout>
            </template>
        </v-data-table>
        <v-dialog v-model="addMyQuestionDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Добавить вопрос</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="myQuestion.text" dense placeholder="Текст дополнительного вопроса"></v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="myQuestion.cat_id" dense item-text="cat_name" item-value="cat_id" :items="cats" placeholder="Выберите категорию ШБ"></v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="addMyQuestionClose">Отмена</v-btn>
                    <v-btn color="blue darken-1" text @click="addMyQuestionSave">Добавить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

  import AnswerPlace from './answerPlace'
  import PointChanger from './pointChanger'
  import CommentEditor from './commentEditor'
  import FileSelector from './fileSelector'
  import StoCommentEditor from './stoCommentEditor'
  import StoFileLoader from './stoFileLoader'

  export default {
    name: 'basicTable',
    props: ['value', 'images', 'deletemode', 'mode', 'stage'],
    components: { StoFileLoader, StoCommentEditor, FileSelector, CommentEditor, PointChanger, AnswerPlace },
    data () {
      return {
        cats: [],
        addMyQuestionDialog: false,
        subMode: this.mode,
        myQuestion: {
          text: null,
          cat_id: null,
        },
        headers: [
          { text: 'Вопрос', align: 'left', value: 'question', width: '22%', sortable: false, },
          { text: 'Ответ', value: 'answer', sortable: false,  },
          { text: 'Файл', value: 'file', sortable: false  },
          { text: 'Предыдущая оценка', value: 'last_point', sortable: false, align: 'center'  },
          { text: 'Оценка', value: 'point', sortable: false,   },
          { text: 'Итоговая оценка', value: 'point_to_reports', sortable: false, align: 'center' },
          { text: 'Комментарий', value: 'comment', sortable: false,  },
          { text: 'Исключить', value: 'exclude', sortable: false, align: 'center' },
          { text: 'Блок', value: 'admin_block_id', sortable: false,  },
          { text: 'Коммент СТО', value: 'sto_comment', sortable: false,  },
          { text: 'Файл СТО', value: 'sto_file', sortable: false,  },
        ],
        points: this.value,
        adminBlocks: [],
      }
    },
    filters: {

    },
    computed: {
      mainHeaders() {
        let newHeaders = this.headers
        if(!!this.showAdminUI) {
          if(this.stage === 'C30:1' || this.stage === 'C30:2' || this.stage === 'C30:WON') return this.headers
          newHeaders.splice(this.headers.length - 2, 2)
        } else {
          return this.headers
        }
        return newHeaders
      },
      showAdminUI() {
        return this.mode === 'manager' || this.mode === undefined
      },
      showFranch() {
        return this.mode === 'franch'
      },
      showAccount() {
        return this.mode === 'account'
      },
      showUK() {
        return this.mode === 'uk'
      },
      calculateAdditional() {
        let adds = this.points.filter(p => p.admin_block_id === 14) || []
        return adds.length
      }
    },
    methods: {
      itemClassFn(item) {
        return item.exclude || item.admin_block_id === 9
          ? 'excludedItem'
          : ''
      },
      deletePoint(itemKey) {
        console.log('item to delete', itemKey)
        let index = -1

        for(let i in this.points) {
          if(itemKey === this.points[i].itemKey) {
            index = i
            break
          }
        }

        if(index > -1) {
          this.points.splice(index, 1)
          this.$nextTick(function () {
            this.change()
          })
        }


      },
      addMyQuestion() {
        console.log('assmq')
        this.myQuestion.cat_id = null
        this.myQuestion.text = null
        this.addMyQuestionDialog = true
      },
      addMyQuestionSave() {
        this.points.push({
          point: 0,
          last_point: 1,
          point_to_reports: 0,
          exclude: false,
          cat_id: this.myQuestion.cat_id,
          comment: null,
          sto_comment: null,
          file: null,
          sto_file: null,
          question: this.myQuestion.text,
          answer: null,
          admin_block_id: 14,
          act_text: this.myQuestion.text,
          itemKey: this.points.length
        })
        this.change()
        this.$nextTick(function () {
          this.addMyQuestionClose()
        })
      },
      addMyQuestionClose() {
        this.addMyQuestionDialog = false
      },
      showNoSearch(value, search, item) {
        return item.admin_block_id.toString() !== search
      },
      change() {
        this.$emit('input', this.points)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      adminBlockName: function (value) {
        for (let block of this.adminBlocks) {
          if (+(value) === block.admin_block_id) return block.admin_block_name
        }
      },
      async getAdminBlocks () {
            try {
              const r = await this.$http.get(`${this.$store.getters.api}v3/bots/shopper/adminsblocks`)
              this.adminBlocks = r.data
            } catch (e) {
                console.log(e)
            }
      },
      async getCats () {
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v3/bots/shopper/cats`)
          this.cats = r.data
        } catch (e) {
          console.log(e)
        }
      }
    },
    mounted () {
      this.getAdminBlocks()
      this.getCats()
    },
    updated () {
    }
  }
</script>

<style>
.excludedItem {
  color: #545454;
  background-color: #eee;
}

.excludedItem td {
  color: #545454;
  background-color: #eee;
}

</style>
